<div class="modal-header">
    <h4 class="modal-title pull-left">Select Broker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <div class="table-responsive">
            <div>
                <input class="form-control be-input margin-bottom-20" [(ngModel)]="searchValue" (keyup)="searchExchange(searchValue)" maxlength="200" placeholder="Search Broker">
            </div>
            <table class="table basictable row-border hover" id="dtTable" datatable [dtOptions]="dtOptions">
                <tbody>
                    <tr *ngFor="let user of users;let i = index ">
                        <td>
                            <ul class="connection-list brokerlist be-exchange-list">
                                <li class="clearfix">
                                    <img [src]="user.ProfilePic !=='' ? user.ProfilePic  :'/../../../assets/img/default-profile-img.png'" />
                                    <div class="right">
                                        <h6>
                                            {{user.FirstName + ' '+ user.LastName}}
                                        </h6>
                                        <p>
                                            <i class="icon-phone icon"></i> {{user.Phone|phone}}
                                        </p>
                                        <p>
                                            <i class="icon-message icon"></i> {{user.Email}}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <p><a href="javascript:void(0);" class="be-small-atag pull-right" (click)="onUserSelect(user)">Select</a></p>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr *ngIf="users?.length == 0 ">
                        <td colspan="15" class="odd no-data-available">
                            <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>